import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Attachment } from '../_models/attachment';
import { Index } from '../_models/index';
import { Block } from '../_models/block';

@Injectable({
  providedIn: 'root'
})
export class IndexesService {

  private locale: string = 'pt';

  constructor(
    private http: HttpClient
  ) {
  }

  all(): Observable<Index[]> {
    return this.http.get<Index[]>(`${this.locale}/indexes`)
      .pipe(
        map(indexes => {
          for (let index = 0; index < indexes.length; index++) {
            let indexObj = indexes[index];
            indexObj.dontShow = false;
            indexes[index] = indexObj;
          }

          return indexes;
        }),
        catchError(this.handleError)
      );
  }

  detail(id : number): Observable<Index> {
    return this.http.get<Index>(`${this.locale}/indexes/${id}`)
      .pipe(
        tap(_ => console.log("Index fetched: ", _)),
        catchError(this.handleError)
      );
  }

  attachments(id : number): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(`${this.locale}/indexes/${id}/attachments`)
      .pipe(
        tap(_ => console.log("Attachments fetched: ", _)),
        catchError(this.handleError)
      );
  }

  blocks(id : number): Observable<Block[]> {
    return this.http.get<Block[]>(`${this.locale}/indexes/${id}/blocks`)
      .pipe(
        tap(_ => console.log("Blocks fetched: ", _)),
        catchError(this.handleError)
      );
  }

  previous(id: number): Observable<Index> {
    return this.http.get<Index>(`${this.locale}/indexes/${id}/previous`)
      .pipe(
        tap(_ => console.log("Index fetched: ", _)),
        catchError(this.handleError)
      );
  }

  next(id: number): Observable<Index> {
    return this.http.get<Index>(`${this.locale}/indexes/${id}/next`)
      .pipe(
        tap(_ => console.log("Index fetched: ", _)),
        catchError(this.handleError)
      );
  }

  private handleError(error: Response) {
    console.error(JSON.stringify(error));
    console.error(error);
    return Observable.throw(error.statusText);
  }
}
